import {useModelEdit} from "../../../hooks/useModelEdit";
import {useMedia} from "../../../../../../newShared/hooks/useMedia";
import {useMainTranslation} from "../../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {Flex} from "../../../../../../newShared/components/Layouts";
import * as S from "../../../components/styled";
import colors from "../../../../../../newShared/theme/colors";
import {Button, IconButton, TextField, Typography} from "@mui/material";
import CommonLoading from "../../../../../../newShared/components/Basic/CommonLoading";
import {CustomSlider} from "../../../components/customSlider";
import {ModelTable} from "../../../components/modelTable";
import React from "react";
import {LoadingButton} from "@mui/lab";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import {IconTextButton} from "../../../../../../newShared/components/Basic/CommonButtons";
import AddIcon from "@mui/icons-material/Add";
import {PageTitleAndActions} from "../../../../../../newShared/components/pageTitleAndActions";


export const ModelsEdit = () => {
    const {
        handleGoBack,
        max,
        low,
        isLoading,
        model,
        isOk,
        handleSubmit,
        isLoadingModels,
        setLeftRight,
        handleChangeProbability,
        handleChangeImpact,
        handleDeleteProbability,
        handleDeleteImpact,
        handleAddProbability,
        handleAddImpact,
        //
        isCanBeApplied,
        handleApplyChanges,
        isOkToApply,
        displayModel
    } = useModelEdit();

    const {isMobile} = useMedia();
    const {revDir, t} = useMainTranslation('', {keyPrefix: 'risks'});

    return(
        <Flex w={'100%'} h={'100%'} direction={'column'}>
            <PageTitleAndActions
                title={model?.name}
                handleGoBack={handleGoBack}
                actions={[]}
            />

            <Typography variant={'body2'} color={colors.text.grey_dark} sx={{margin: '8px 0 0 0'}}>{t('Used count_doubleDot {{counter}}', {counter: model?.counter ?? 0})}</Typography>

            <Flex ai={'center'} m={'32px 0 5px 0'}>
                {isLoading ?
                    <LoadingButton
                        loading
                        sx={{width: '190px', paddingLeft: '30px', margin: !revDir ? '0 16px 0 0' : '0 0 0 16px'}}
                        variant="outlined"
                    >{t('Save')}</LoadingButton>
                    :
                    <Button
                        disabled={!isOk() || isCanBeApplied} //if model can be applied - used did not see changes
                        variant={'contained'}
                        size={isMobile ? 'small' : 'medium'}
                        onClick={handleSubmit}
                        sx={{margin: !revDir ? '0 16px 0 0' : '0 0 0 16px'}}
                    >{t('Save')}</Button>
                }
                <Button disabled={isLoading} variant={'outlined'} size={isMobile ? 'small' : 'medium'} onClick={handleGoBack} >{t('Cancel')}</Button>

                {/*<Typography>low:{low} - left:{displayModel?.left} | right:{displayModel?.right} - max:{max}</Typography>*/}
            </Flex>

            {isLoadingModels && <CommonLoading margin={'10px 0 0 0'}/>}

            {model &&
                <S.EditModelWrapper>
                    {/*//INPUTS*/}
                    <S.EditModelInputsContainer>
                        <S.EditModeInputWrapper>
                            <Typography variant={'subtitle2'} color={colors.text.grey_dark} sx={{margin: '8px 0'}}>Probability scale</Typography>
                            {model.probabilities.map((e, id) => {
                                return(
                                    <Flex ai={'center'} m={'0 0 8px 0'} key={`Probability-${id}`}>
                                        <TextField
                                            value={e.quality}
                                            label={t('Quality')}
                                            onChange={(e) => handleChangeProbability(e, id)}
                                            name={'quality'}
                                            size={'small'}
                                            error={!e.quality.trim().length}
                                            sx={{margin: !revDir ? '0 8px 0 0': '0 0 0 16px'}}
                                        />

                                        <TextField
                                            value={e.quantitative}
                                            onChange={(e) => handleChangeProbability(e, id)}
                                            name={'quantitative'}
                                            size={'small'}
                                            type={'number'}
                                            InputProps={{inputProps: {min: 1}}}
                                            label={t('Quantitative')}
                                        />

                                        {model.probabilities.length > 1 &&
                                            <IconButton onClick={() => handleDeleteProbability(id)}>
                                                <DeleteForeverRoundedIcon fontSize={'small'} />
                                            </IconButton>
                                        }
                                    </Flex>
                                )
                            })}

                            <Flex>
                                <IconTextButton
                                    variant={'text'}
                                    icon={<AddIcon fontSize="small"/>}
                                    onClick={handleAddProbability}
                                    sx={{
                                        '& .MuiButton-startIcon': {margin: !revDir ? '0 8px 0 -4px': '0 -4px 0 8px',}
                                    }}
                                >{t('Add probability')}
                                </IconTextButton>
                            </Flex>
                        </S.EditModeInputWrapper>

                        <S.EditModeInputWrapper>
                            <Typography variant={'subtitle2'} color={colors.text.grey_dark} sx={{margin: '8px 0'}}>Impact scale</Typography>
                            {model.impacts.map((e, id) => {
                                return(
                                    <Flex ai={'center'} m={'0 0 8px 0'} key={`Impact-${id}`}>
                                        <TextField
                                            value={e.quality}
                                            label={t('Quality')}
                                            name={'quality'}
                                            error={!e.quality.trim().length}
                                            size={'small'}
                                            onChange={(event) => handleChangeImpact(event, id)}
                                            sx={{margin: !revDir ? '0 8px 0 0': '0 0 0 16px'}}
                                        />

                                        <TextField
                                            value={e.quantitative}
                                            type={'number'}
                                            // InputProps={{ inputProps: { min: 0} }}
                                            name={'quantitative'}
                                            size={'small'}
                                            label={t('Quantitative')}
                                            InputProps={{inputProps: {min: 1}}}
                                            onChange={(event) => handleChangeImpact(event, id)}
                                        />

                                        {model?.impacts.length > 1 &&
                                            <IconButton onClick={() => handleDeleteImpact(id)}>
                                                <DeleteForeverRoundedIcon fontSize={'small'} />
                                            </IconButton>
                                        }
                                    </Flex>
                                )
                            })}

                            <Flex>
                                <IconTextButton
                                    variant={'text'}
                                    icon={<AddIcon fontSize="small"/>}
                                    onClick={handleAddImpact}
                                    sx={{
                                        '& .MuiButton-startIcon': {margin: !revDir ? '0 8px 0 -4px': '0 -4px 0 8px',}
                                    }}
                                >{t('Add impact')}
                                </IconTextButton>
                            </Flex>
                        </S.EditModeInputWrapper>
                    </S.EditModelInputsContainer>

                    <Button
                        disabled={!isCanBeApplied || !isOkToApply}
                        sx={{margin: '16px 0 0 0'}}
                        onClick={handleApplyChanges}
                    >{'Apply changes'}</Button>

                    {/*//TABLE*/}
                    <S.SliderAndModelViewWrapper>
                        {displayModel && <>
                            <CustomSlider model={displayModel} max={max} min={low} editMode={true} setLeftRight={setLeftRight}/>
                            <ModelTable model={displayModel}/>
                        </>}
                    </S.SliderAndModelViewWrapper>
                </S.EditModelWrapper>
            }
        </Flex>
    )
}